import { DirectiveBinding } from "vue";

type ClickOutsideElement = HTMLElement & {
  clickOutsideEvent?: (event: MouseEvent) => void;
};

export const useClickOutside = () => {
  const vClickOutside = {
    mounted(el: ClickOutsideElement, binding: DirectiveBinding<() => void>) {
      if (typeof binding.value !== "function") {
        console.warn("v-click-outside: Binding value must be a function");
        return;
      }

      el.clickOutsideEvent = (event: MouseEvent) => {
        if (!el || !event.target || el.contains(event.target as Node)) {
          return;
        }
        binding.value();
      };

      document.addEventListener("click", el.clickOutsideEvent, {capture: true});
    },
    unmounted(el: ClickOutsideElement) {
      if (el.clickOutsideEvent) {
        document.removeEventListener("click", el.clickOutsideEvent, {capture: true});
        delete el.clickOutsideEvent;
      }
    },
  };

  return { vClickOutside };
};
